module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/connect-b0117badba586ca1eef185c38f07a9c3.png";